import React from "react";

const ContractsContext = React.createContext({});

export default ContractsContext;